// extracted by mini-css-extract-plugin
export default {"loaderContainer":"basic-loader_loaderContainer__mzQbm","innerContainer":"basic-loader_innerContainer__y0gJO","spin":"basic-loader_spin__C4ApH"};